import { CrewDTO } from "@/api/dto/SignoutDTO";

export interface ISignout {
  id: number;
  program: number | null;
  type: string | null;
  boat: string | null;
  sail: string | null;
  role: string | null;
  signOutDate: string | null;
  signInDate: string | null;
  crew: CrewDTO[] | null;
  skipper: CrewDTO | null;
  assignedTo: number | null;
  testRating: string | null;
  testResults: string | null;
}

export class Signout implements ISignout {
  id;
  program;
  type;
  boat;
  sail;
  role;
  signOutDate;
  signInDate;
  crew;
  skipper;
  assignedTo;
  testRating;
  testResults;

  constructor(config: ISignout) {
    this.id = config.id;
    this.program = config.program;
    this.type = config.type;
    this.boat = config.boat;
    this.sail = config.sail;
    this.role = config.role;
    this.signOutDate = config.signOutDate;
    this.signInDate = config.signInDate;
    this.crew = config.crew;
    this.skipper = config.skipper;
    this.assignedTo = config.assignedTo;
    this.testRating = config.testRating;
    this.testResults = config.testResults;
  }

  getRole(id: number) {
    return this.assignedTo === id ? "Skipper" : "Crew";
  }

  getSignOutDate() {
    return (
      this.signOutDate &&
      new Date(this.signOutDate).toLocaleString("en-us", { timeZone: "UTC" })
    );
  }

  getSignInDate() {
    return (
      this.signInDate &&
      new Date(this.signInDate).toLocaleString("en-us", { timeZone: "UTC" })
    );
  }
}
